import {instance} from "../../../config/axios-cnf";

// Sestaví URL pro dashboard info; from/to volitelné (ISO-8601 lokální datetime).
export const buildDashboardInfoUrl = (subjectId, from, to) => {
    const qs = (from && to)
        ? `?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`
        : "";
    return `/api/v2/enigoo/${subjectId}/dashboard/info${qs}`;
};

export const apiGetDashboardInfo = (subjectId, from, to, callback, error) => {
    instance.get(buildDashboardInfoUrl(subjectId, from, to))
        .then(response => callback(response.data))
        .catch(err => error(err));
};
